import React from "react";
import ConvertAmountToWords from "./AmountConverter";
import { Tooltip, Typography } from "@mui/material";
import { NumberFormatter } from "./NumberFormatter";

const AmountInfo = ({ amount, color, fontWeight, fontSize, calculate }) => {
  const formattedAmount = Math.abs(amount).toFixed(2);
  const isZero = parseFloat(formattedAmount) === 0;
  return (
    <Tooltip
      title={
        !isZero && (
          <Typography>
            <ConvertAmountToWords amount={formattedAmount} />
          </Typography>
        )
      }
      placement="bottom-start"
    >
      <span
        style={{
          color: color,
          fontSize: fontSize || 14,
          cursor: "pointer",
          fontWeight,
        }}
      >
        {isZero && calculate ? (
          "-"
        ) : (
          <NumberFormatter number={formattedAmount} />
        )}
      </span>
    </Tooltip>
  );
};

export default AmountInfo;
